/**
+ * JSON Schema for the req.body object of the reset password endpoint.
+ *
+ * http://json-schema.org/
+ */

export default {
  id: "resetPasswordSchema",
  type: "object",
  properties: {
    username: {
      type: "string",
      required: true
    },
    newPassword: {
      type: "string",
      required: true
    },
    confirmationType: {
      type: "string",
      required: true
    },
    confirmationCode: {
      type: "string",
      required: true
    },
    invalidatePreviousTokens: {
      type: "boolean",
      required: false
    }
  }
};
